<template>
	<div class="d-flex justify-content-center outer-div">
		<div class="pt-5 mt-5"></div>
		<div class="row ">
			<div class="col-sm-12 col-md-6">
				<img src="@/assets/travel.png" alt="" />
			</div>
			<div class="col-sm-12 col-md-6 mt-sm-5">
				<div class="card-items  mx-2">
					<h1
						class=" mb-0 d-flex align-items-center justify-content-center text-blue fs-2"
					>
						Login
					</h1>
					<div class="card-body">
						<AuthLogin />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import AuthLogin from "@/components/AuthLogin";
	export default {
		name: "Login",
		components: {
			AuthLogin,
		},
	};
</script>
<style scoped>
	.row{
		display: flex;
		align-items: center;
	}
	img{
		width: 100%;
		height: auto;
	}
	
</style>
